import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {PlanningViewSettingsResourcesModel} from "../../../models/planning-view-settings.model";
import {PlanningRouteModel} from "../../../models/planning-route.model";

require('./planning-draft-resources-panel-list-item.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-resources-panel-list-item',
  templateUrl: './planning-draft-resources-panel-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftResourcesPanelListItemComponent implements OnInit, OnChanges {

  @Input() draft?: any;
  @Input() resource: any;
  @Input() resourceRoutes: PlanningRouteModel[] = [];
  @Input() settings: PlanningViewSettingsResourcesModel;
  @Input() isSelected?: boolean;
  @Input() canClose?: boolean;
  @Input() itemElementSize?: string;
  @Output() onEditResourceAllocation = new EventEmitter<{resource: any, route: any, event: any }>();
  @Output() onToggle = new EventEmitter<boolean>();
  @Output() onClose = new EventEmitter<any>();
  @Output() onDispatch = new EventEmitter<string>();
  @Output() onDrilldown = new EventEmitter<any>();

  public capacity: {
    type: string;
    value: string;
    maxValue: string;
    icon: string;
    percentage: number;
  }
  public routeColor: string;
  public dateRange: {notBefore: string, notAfter: string}
  public routesCount: number = 0;
  public totalDuration: number = 0;
  // Never assigned - the template reads route.* (income, capacity) but only resourceRoutes is provided.
  public route: PlanningRouteModel;

  constructor(@Inject('planningCommonService') private planningCommonService, @Inject('$timeout') private $timeout) {

  }

  ngOnInit() {
    this.setRouteColor();
    this.totalDuration = this.resourceRoutes?.reduce((acc, route) => { return acc += route.totals.totalTimeSec }, 0);
  }

  onDrilldownClick(event: Event) {
    this.onDrilldown.emit(this.resource);
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.settings && !changes.settings.isFirstChange()) || (changes.resourceRoutes && !changes.resourceRoutes.isFirstChange())) {
      this.setRouteColor();
      this.totalDuration = this.resourceRoutes?.reduce((acc, route) => { return acc += route.totals.totalTimeSec }, 0);
    }
  }

  getTotalIncomeClass(totalIncome?) {
    const minimumRouteIncome = this.resource.routeIncomePreferences?.minimumRouteIncome || this.draft?.settings?.incomeSettings?.minRouteIncome;
    const maximumRouteIncome = this.resource.routeIncomePreferences?.maximumRouteIncome || this.draft?.settings?.incomeSettings?.maxRouteIncome;
    return (!!minimumRouteIncome && (totalIncome < minimumRouteIncome)) ? 'low' :
      ((!!maximumRouteIncome && (totalIncome > maximumRouteIncome)) ? 'high' : '');
  }

  private setRouteColor() {
    const route = this.resourceRoutes?.[0];
    this.routeColor = route ? this.planningCommonService.getRouteColor(route) : undefined;
  }
}
